import { getSupplySnapshot } from "../selectors/supply";
import type {
  ActionValidationFailure,
  ActionValidationResult,
  DiscardArmyForUpkeepAction,
  GameState,
} from "../types";

function invalid(
  code: ActionValidationFailure["code"],
  message: string,
  path: string | null = null,
  details: ActionValidationFailure["details"] = {},
): ActionValidationResult {
  return { valid: false, failure: { code, message, path, details } };
}

export function validateDiscardArmyForUpkeepAction(
  state: Readonly<GameState>,
  action: DiscardArmyForUpkeepAction,
): ActionValidationResult {
  if (state.schemaVersion !== 3 && state.schemaVersion !== 4 && state.schemaVersion !== 5) {
    return invalid(
      "ACTION_NOT_IMPLEMENTED",
      "Supply Upkeep actions require a catalog-schema-2 match.",
      "type",
      { actionKind: "supply-resolution" },
    );
  }
  if (state.phase !== "supply") {
    return invalid("WRONG_PHASE", "Army Upkeep removal is legal only during Supply.", "phase", {
      currentPhase: state.phase,
      requiredPhase: "supply",
    });
  }
  if (state.supplyStatus.type !== "awaiting-upkeep-discard") {
    return invalid(
      "SUPPLY_NOT_AWAITING_DISCARD",
      "Supply is not waiting for a mandatory Army discard.",
      "supplyStatus",
      { supplyStatus: state.supplyStatus.type },
    );
  }

  const snapshot = getSupplySnapshot(state);
  const lane = snapshot.lanes[action.laneId];
  if (!lane.active || lane.sustainable) {
    return invalid(
      "SUPPLY_LANE_NOT_UNSUSTAINABLE",
      "An Army can be removed for Upkeep only from an unsustainable active lane.",
      `lanes.${action.laneId}`,
      { laneId: action.laneId, active: lane.active, sustainable: lane.sustainable },
    );
  }
  if (!lane.armyCardInstanceIds.includes(action.armyCardInstanceId)) {
    return invalid(
      "ARMY_NOT_STATIONED_IN_LANE",
      "The selected Army is not stationed in the target lane.",
      `lanes.${action.laneId}.players.${action.playerId}.armies`,
      { laneId: action.laneId, armyCardInstanceId: action.armyCardInstanceId },
    );
  }

  return { valid: true };
}
